export default __webpack_public_path__ + "static/media/icon-enroute.80f8cabc.svg";